import * as Yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";

Yup.addMethod(Yup.mixed, "phone", function (message = "Invalid phone number") {
  return this.test("phone", message, function (value, context) {
    const fieldName = context.path;
    if (fieldName?.toLowerCase().includes("phone")) {
      if (!value) return true;
      return isValidPhoneNumber(value as string);
    }
    return true;
  });
});

export default Yup;
